module.exports = __webpack_public_path__ + "media/flags/006-turkey-4d0cc377.svg";